import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const LaurentsSeries = () => (
  <QPhototModuleSubtopic
    title="Laurent's series"
    videos={[
      "https://www.youtube.com/embed/gUmIrJRXDSs",
      "https://www.youtube.com/embed/9LI60ampQzs",
      "https://www.youtube.com/embed/ZQBrfSJJxO8",
      "https://www.youtube.com/embed/xKxziml7eag"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_25.png"},
        {image:"/cvla_26.png"},
        {image:"/cvla_27.png"},
        {image:"/cvla_28.png"},
        {image:"/cvla_29.png"},

    ]}
    exampleVideos={[]}
  />
);

export default LaurentsSeries;
